import { Link } from "react-router-dom";
import { useRouteMeta } from "@/lib/seo";

export function NotFoundPage() {
  useRouteMeta({
    title: "Page not found — Soweto Super United FC",
    description: "The page you're looking for doesn't exist or has moved.",
    noindex: true,
  });
  return (
    <main className="flex min-h-dvh items-center justify-center bg-background px-4">
      <div className="text-center">
        <p className="font-display text-6xl text-primary">404</p>
        <h1 className="mt-2 font-display text-2xl">Page not found</h1>
        <p className="mt-2 text-muted-foreground">
          The page you're looking for doesn't exist or has moved.
        </p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:opacity-90"
        >
          Return home
        </Link>
      </div>
    </main>
  );
}
